/** VIN decode autofill helpers (NHTSA vPIC via backend). */

const VIN_RE = /^[A-HJ-NPR-Z0-9]{17}$/;

const FILL_KEYS = [
  "make",
  "model",
  "trim",
  "year",
  "vehicle_type",
  "powertrain",
  "transmission",
  "seats",
];

export function isCompleteVin(value) {
  return VIN_RE.test(String(value || "").trim().toUpperCase());
}

export function normalizeVinInput(value) {
  return String(value || "")
    .toUpperCase()
    .replace(/[^A-HJ-NPR-Z0-9]/g, "")
    .slice(0, 17);
}

/** Merge decode fields into a listing form object (host can still edit). */
export function applyVinFields(form, fields) {
  if (!form || !fields || typeof fields !== "object") return form;
  const next = { ...form };
  for (const key of FILL_KEYS) {
    const value = fields[key];
    if (value === undefined || value === null || value === "") continue;
    next[key] = value;
  }
  return next;
}

export function vinDecodeErrorMessage(detail) {
  if (detail === "invalid_vin") return "Enter a full 17-character VIN to autofill.";
  if (detail === "vin_decode_failed") {
    return "We could not decode that VIN. Check the number or fill the details manually.";
  }
  if (detail === "vin_decode_unavailable") {
    return "VIN lookup is temporarily unavailable. Fill the details manually.";
  }
  if (detail === "kyc_required") return "Verify your identity before listing a vehicle.";
  if (detail === "owner_role_required") return "Switch to a host account to list a vehicle.";
  return "Could not autofill from VIN. Fill the details manually.";
}
